const modelHomoglyphs = {а: 'a', в: 'b', с: 'c', е: 'e', н: 'h', к: 'k', м: 'm', о: 'o', р: 'p', т: 't', х: 'x', у: 'y'};

export const normalizeSearch = value => String(value).toLowerCase().replace(/ё/g, 'е')
    // Normalize lookalikes only in alphanumeric model codes, preserving ordinary words and string offsets.
    .replace(/[a-zа-я0-9]+/g, token => /\d/.test(token) && /^[a-zавсенкмортху0-9]+$/.test(token)
        ? token.replace(/[авсенкмортху]/g, letter => modelHomoglyphs[letter])
        : token);
const ignored = new Set(['image', 'images', 'img', 'url', 'link', 'to', 'type', 'state', 'color', 'position', 'backGround', 'doc', 'requestName']);
export function collectText(value) {
    if (typeof value === 'string' || typeof value === 'number') return String(value);
    if (Array.isArray(value)) return value.map(collectText).filter(Boolean).join(' ');
    if (!value || typeof value !== 'object') return '';
    return Object.entries(value).filter(([key]) => !ignored.has(key)).map(([, child]) => collectText(child)).filter(Boolean).join(' ');
}
export function buildSearchIndex(structure, products, services, news, content, knowledge = []) {
    const documents = [];
    function visit(nodes, parent = '', ancestors = []) {
        Object.entries(nodes).forEach(([key, node]) => {
            const url = `${parent}/${key}`;
            const type = node.type === 'product' ? 'product' : node.type === 'service' ? 'service' : 'page';
            const description = type === 'product' ? products[node.title]?.content : type === 'service' ? services[key]?.content : node.seo?.description;
            const body = collectText([
                description,
                node.property?.title,
                node.property?.text,
                node.property?.about
            ]);
            if (node.title) documents.push({title: node.title, url, type, body, sections: ancestors.slice(1), image: node.image ? `/images/${String(node.image).replace(/^\.?\//, '')}` : ''});
            if (node.links) visit(node.links, url, [...ancestors, node.title]);
        });
    }
    visit(structure);
    news.forEach(item => documents.push({title: item.title, url: item.url, type: 'news', date: item.date, image: item.image, body: [item.previewText, collectText(content[item.title]?.content)].filter(Boolean).join(' ')}));
    knowledge.forEach(item => documents.push({
        title: item.title,
        url: `/knowledge-base/${item.slug}`,
        type: 'knowledge',
        category: item.category,
        body: collectText([item.excerpt, item.intro, item.sections, item.sources])
    }));
    return documents.map(item => ({...item, normalizedTitle: normalizeSearch(item.title), normalizedBody: normalizeSearch(item.body)}));
}
export function findSearchResults(index, query) {
    const terms = [...new Set(normalizeSearch(query).trim().split(/[\s,]+/).filter(Boolean))];
    if (!terms.length) return [];
    return index.filter(item => terms.every(term => `${item.normalizedTitle} ${item.normalizedBody}`.includes(term)))
        .map(item => ({...item, score: (item.normalizedTitle.includes(terms.join(' ')) ? 100 : 0) + terms.filter(term => item.normalizedTitle.includes(term)).length * 10}))
        .sort((a, b) => b.score - a.score);
}
export function searchSnippet(item, query) {
    const terms = normalizeSearch(query).trim().split(/[\s,]+/).filter(Boolean);
    const positions = terms.map(term => item.normalizedBody.indexOf(term)).filter(position => position >= 0);
    let start = positions.length ? Math.max(0, Math.min(...positions) - 55) : 0;
    while (start > 0 && !/\s/.test(item.body[start - 1])) start--;
    const end = Math.min(item.body.length, start + 210);
    return `${start ? '…' : ''}${item.body.slice(start, end)}${end < item.body.length ? '…' : ''}`;
}
